import { type SystemToastProps } from '@wellesley/system-toast'
import { createIDAction } from '../helpers/createIDAction'
import { createAction } from '../helpers/createAction'

export type ShowToastMessageAction = ReturnType<typeof showToastMessageAction>

export const showToastMessageAction =
  createIDAction<SystemToastProps>('showToastMessage')

export const clickOnToastButtonAction =
  createIDAction<void>('clickOnToastButton')
export type ClickOnToastButtonAction = ReturnType<
  typeof clickOnToastButtonAction
>

export const closeToastAction = createIDAction<void>('closeToast')
export type CloseToastAction = ReturnType<typeof closeToastAction>

export const dismissToastAction = createAction<{ toastId: string | number }>(
  'dismissToast',
)
export type DismissToastAction = ReturnType<typeof dismissToastAction>
